import { render, staticRenderFns } from "./AboutCustomize.vue?vue&type=template&id=bb2a78fe&"
import script from "./AboutCustomize.vue?vue&type=script&lang=js&"
export * from "./AboutCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports